export default class EventListeners {

	constructor() {
		HTMLElement.prototype.addMultipleEventListeners = function (events, handler) {
			events.split(' ').forEach(e => this.addEventListener(e, handler));
		};
	}
}
